import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Emails come from Cognito on one side and DynamoDB on the other, so compare
// them case- and whitespace-insensitively rather than with ===.
export function sameEmail(a, b) {
  return Boolean(a) && Boolean(b) && a.trim().toLowerCase() === b.trim().toLowerCase();
}

export function formatBytes(bytes) {
  if (bytes === 0) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
}

export function formatDate(iso) {
  if (!iso) return "—";
  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(iso));
}

export function formatDateShort(iso) {
  if (!iso) return "—";
  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(new Date(iso));
}

export function rollbackRatePercent(rate) {
  return (rate * 100).toFixed(1) + "%";
}

/**
 * Render a target-country list. Entries arrive either as plain codes or as
 * { name, code } objects, depending on the endpoint.
 *
 * `emptyValue` differs by call site: the tables and PDF want an em dash, the
 * summary rows want null so the row is skipped entirely.
 */
export function formatTargetCountries(arr, emptyValue = "—") {
  if (!Array.isArray(arr) || !arr.length) {
    return emptyValue;
  }
  return arr.map((c) => (typeof c === "object" ? `${c.name} (${c.code})` : c)).join(", ");
}
